import { UxTheme } from "../globals/globals";

export const setTheme = (theme: UxTheme) => {
    window.trumpf.ux.theme = theme;
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `:root { --trumpf-ux-theme: ${theme}; }`;
    document.head.appendChild(styleElement);
    const event = new Event("uxThemeChange");
    window.dispatchEvent(event);
};
